import React, { ReactNode } from 'react';
import { FONT_FAMILY_STYLES } from '../Pharmacy/PharmacyPlan/PharmacyPlan.constants';
import { IEntityComparePanelProps } from './EntityComparePanel';

interface IComparisonTitleProps {
    changed?: boolean;
    name?: ReactNode;
    children?: ReactNode;
    entityProps: Pick<IEntityComparePanelProps, 'markers'>;
}

export const CompareTitle: React.FC<IComparisonTitleProps> = (props) => (
    <div>
        <span style={FONT_FAMILY_STYLES}>
            {(props.changed ? props.entityProps.markers.MARKER_ON : props.entityProps.markers.MARKER_OFF)}
        </span>
        <span>
            {props.name ?? props.children}
        </span>
    </div>
);
